import { render, staticRenderFns } from "./LayoutTicket.vue?vue&type=template&id=2969b2de&scoped=true&"
import script from "./LayoutTicket.vue?vue&type=script&lang=ts&"
export * from "./LayoutTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2969b2de",
  null
  
)

export default component.exports